import logoVR from "./assets/logos/logo.png";
import logoCStudio from "./assets/logos/LogoCSTUDIO.png";
import logoClubTech from "./assets/logos/ClubTech.png";
import logoCSDesign from "./assets/logos/CSDesign.png";
import logoLinkCS from "./assets/logos/linkcs.png";
import logoPics from "./assets/logos/pics.png";
import logoCRACS from "./assets/logos/CRACS.png";
import logoHyris from "./assets/logos/Hyris.png";
import logoGachaAddiCS from "./assets/logos/GachaAddiCS.png";
import logoCACS from "./assets/logos/CACS.jpg"

import { createContext } from "react";

const Session = createContext(null);

const assoCStudio = {
  name: "CStudio",
  pathLogo: logoCStudio,
  texteAsso:
    "Les jeux vidéo c’est sympa, mais comment en concevoir un soi-même ? Avec CStudio, apprends toutes les bases pour créer un jeu : de la manipulation de moteur 3D comme Unity à celle de modélisateur 3D comme Blender en passant par les principes du Game Design. Avec nous, tu auras l’opportunité de mettre ces connaissances en pratique lors de sessions de code cohez, de projets persos ou de groupe, ou même lors de Game Jams ! Le club est ouvert à toutes et à tous pour redécouvrir la passion du jeu vidéo ensemble !CStudio est l'association de développement de Jeux Vidéo de CentraleSupélec, on est super cool et funs ! n'hésite pas à nous rejoindre quand tu veux =)",
  website: "https://cstudio.cs-campus.fr/",
};

const assoVR = {
  name: "ViaRézo",
  pathLogo: logoVR,
  texteAsso:
    "ViaRézo (ou VR) est une association d'informatique et de réseaux omniprésente à CentraleSupélec et à Césal : nous fournissons un wifi haut débit aux étudiants dans les résidences à l'aide d'une infrastructure conséquente, constituée de matériel professionnel. De plus, nous développons des services web avec les technologies les plus répandues et nous organisons, en partenariat avec la DGSE, un grand tournoi de cybersécurité (TRACS) 🕵️‍♀️ L'apprentissage prend une très grande place à VR car beaucoup de nos membres y entrent débutant•e•s 😊 Enfin, nous nous retrouvons souvent ensemble pour chill dans notre local autour de bouffes ou films cohez !",
  website: "https://viarezo.fr/",
};

const assoClubTech = {
  name: "Club Tech",
  pathLogo: logoClubTech,
  texteAsso:
    "Le Club Tech est l’asso de tous les passionnés de robotique, mécanique et électronique. Aucun prérequis n'est demandé, nous te formerons lors de projets avec la Fabrique, le FabLab de CS. Tu réalisera de nombreux prototypes et laissera cours à ton imagination. Rejoins nous pour réaliser des projets/compétitions ensemble, comme une borne d’arcade, un robot Beer Pong ou la mythique Coupe de France de Robotique...",
  website: "https://linkcs.fr/association/club-tech-50",
};

const assoCSDesign = {
  name: "CS Design",
  pathLogo: logoCSDesign,
  texteAsso:
    "CS Design, ou juste « le Design », est le club regroupant toutes les personnes passionnées de design graphique. C'est notre club qui crée une grande partie des affiches d'evenements et des logos d'associations sur le campus ! Mais nous ne faisons pas que des affiches ou des logos, nous avons aussi des projets spéciaux. Parmi. eux figurent la carte du campus, la Plaquette Alpha, un jeu de carte aux couleurs de CS, et de nombreux autres projets. Et parce qu'une affiche sur ordinateur c'est bien, mais en papier c'est mieux, nous imprimons des affiches et stickers pour tout le campus. D'ailleurs, nos activités ne s'arrêtent pas aux portes de l'école, nous faisons des prestations extérieures pour l'école, pour des entreprises, des start-ups d'alumni et même un blason pour un satellite du CNES. Alors, si toi aussi tu trouves ça stylé d'embellir le monde autour avec tes créations, rejoins le Design à nos côtés !",
  website: "https://csdesign.cs-campus.fr/",
};

const assoLinkCS = {
  name: "LinkCS",
  pathLogo: logoLinkCS,
  texteAsso:
    "LinkCS est l’association étudiante qui s’occupe du réseau social des étudiant⸱e⸱s qui porte le même nom. Ce site permet de se retrouver dans les grandes promos de  CS – et de ne jamais louper un anniversaire grâce au récapitulatif sur la page d’accueil 🎂 - et donne la possibilité à chacun⸱e d’indiquer ses contacts ainsi que ses associations. Les associations peuvent d’ailleurs écrire des posts pour promouvoir leurs différents évènements. En plus de développer de nouvelles fonctionnalités sur le site, notre équipe personnalise régulièrement le thème du site selon les grands évènements associatifs à venir (quatre fois par mois environ) : il y a toujours des choses à faire ! Nous accueillons à bras ouvert tous⸱tes les intéressé⸱e⸱s pour découvrir comment fonctionne ce site, peu importe son niveau initial en développement web 😁",
  website: "https://linkcs.fr",
};

const assoPics = {
  name: "Pics",
  pathLogo: logoPics,
  texteAsso:
    "Description Pics chasse au trésor : Pics est l’association de photographie de CentraleSupélec. Passionné.e.s de photos, nous immortalisons tous les évènements du campus, des soirées aux activités organisées par les autres associations : c'est l'occasion unique de découvrir de façon privilégiée les coulisses de l'associatif. Nous participons également à des prestations pour des clients extérieurs. Toutes nos photos sont disponibles sur galerie.pics, n'hésite pas à y faire un tour 📸 La plupart de nos membres ont commencé la photographie à CentraleSupélec, nous accueillons donc expert.e.s et débutant.e.s pour expérimenter avec nos nombreux boitiers, objectifs et accessoires divers ou pour tout simplement passer des bons moments avec nous !",
  website: "https://galerie.pics",
};

const assoCRACS = {
  name: "CRACS",
  pathLogo: logoCRACS,
  texteAsso:
    `La Communauté de Réparation d'Artefacts de CentraleSupélec est un club ViaRézo qui a pour vocation de réparer tous types d'objets électroniques / électriques (ordinateurs, télephones, mais aussi grille pains, lampes, etc...).
Notre but ? Lutter contre l'obsolescence programmée et prolonger la durée de vie de vos appareils !
Rejoignez nous tous les mardis entre 12h30 et 13h30 à la Halle (La Fabrique, bâtiment Bouygues) !`,
  website: "https://linkcs.fr/association/cracs-494",
};

const assoHyris = {
  name: "Hyris",
  pathLogo: logoHyris,
  texteAsso:
    `🎥 Hyris, c’est l’association audiovisuelle de CentraleSupélec ! Nous couvrons tous les événements du campus
     – des Nanos aux concerts, en passant par les compétitions sportives – et nous 
     réalisons aussi les DT (Directs Télévisés) avec fictions, récap’ d’événements, 
     Top 50 (remix de chansons bien connues) et mégamix (Interview en soirées, 
     slander et autres contenus drôles). Nous proposons également des prestations pour des entreprises et 
     associations extérieures. Que tu sois passionné.e de vidéo ou simplement curieux.se de découvrir les 
     coulisses de l’audiovisuel, rejoins-nous ! Tu peux voir toutes nos vidéos sur hyris.tv !`,
  website: "https://linkcs.fr/association/hyris-14",
};

const assoGachaAddiCS = {
  name: "GachaAddiCS",
  pathLogo: logoGachaAddiCS,
  texteAsso:
    `Comme son nom l'indique, Gacha AddiCS est l'association de gacha du campus. Pokémon TCG, Genshin Impact, Honkai:Star Rail,
Wuthering Waves… c'est l'occasion pour les membres d'échanger autour de ces jeux. Au programme : visionnages de live d’annonces, débats
sur des théories autour du lore et sessions de tirages — parce qu’invoquer à plusieurs, c’est plus fun (et
ça porte chance… parfois).`,
  website: "https://linkcs.fr/association/gacha-addics-648",
};

const assoCACS = {
  name: "CACS",
  pathLogo: logoCACS,
  texteAsso:
    `Le Cercle Aérospatial de CentraleSupélec est l'association spécialiste des fusées expérimentales, des drones et des aéronefs ! 
  Avec plus de 30 ans d’histoire, on participe chaque année à des compétitions prestigieuses où brillent nos projets ambitieux. 
  L'association fait aussi rayonner l'aérospatiale et l'aéronautique sur le campus au travers des évènements ouverts à tous : conférences, 
  afterwork, moments d'échange. Rejoins un de nos projets techniques pour te faire kiffer et développer des compétences valorisables ;)
`,
    website: "https://linkcs.fr/association/cercle-aeronautique-centralesupelec-302",
};

const listeAsso = [
  assoCStudio,
  assoVR,
  assoPics,
  assoLinkCS,
  assoCSDesign,
  assoClubTech,
  assoCRACS,
  assoHyris,
  assoGachaAddiCS,
  assoCACS
];

export { Session, listeAsso };
